/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncomeDto
 */
export interface IncomeDto {
    /**
     * 
     * @type {string}
     * @memberof IncomeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IncomeDto
     */
    incomeTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof IncomeDto
     */
    value?: number;
}

/**
 * Check if a given object implements the IncomeDto interface.
 */
export function instanceOfIncomeDto(value: object): value is IncomeDto {
    return true;
}

export function IncomeDtoFromJSON(json: any): IncomeDto {
    return IncomeDtoFromJSONTyped(json, false);
}

export function IncomeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncomeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'incomeTypeId': json['incomeTypeId'] == null ? undefined : json['incomeTypeId'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function IncomeDtoToJSON(json: any): IncomeDto {
    return IncomeDtoToJSONTyped(json, false);
}

export function IncomeDtoToJSONTyped(value?: IncomeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'incomeTypeId': value['incomeTypeId'],
        'value': value['value'],
    };
}

